import { Inject, Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GetAllInstitutionsGQL, Institutions } from '@polylearn/models';
import { Observable, of } from 'rxjs';

import { finalize, flatMap, last, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    private _snackBar: MatSnackBar,
    private storage: AngularFireStorage,
    private getAllInstitutionsGQL: GetAllInstitutionsGQL
  ) {}

  getAllInstitutions$(): Observable<any> {
    return this.getAllInstitutionsGQL
      .fetch(
        {},
        {
          context: {
            headers: {
              role: 'limitedAdmin'
            }
          }
        }
      )
      .pipe(res => {
        console.log('res', res);
        return res as any;
      });
  }

  public uploadFile(blob: Blob, filePath: string): Promise<string> {
    const file = blob;
    /*
    if (file.size > 30498064) {
      this._snackBar.open('Le fichier est trop lourd', null, {
        duration: 5000
      });
      return;
    }
    */
    // const filePath = `/users/test/${new Date().toISOString()}.mp3`;

    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    let x = this._snackBar.open(`Audio en cours de téléchargement`, null, {});

    return task
      .snapshotChanges()
      .pipe(
        last(),
        flatMap(() => {
          return fileRef.getDownloadURL();
        }),
        map(rr => {
          x.dismiss();
          console.log(rr);
          return (rr as any) as string;
        })
      )
      .toPromise();
  }
}
